import React from "react";
import { Tooltip } from 'react-tooltip';
import { IExtraLife } from "../utilities/api";

const ExtraLifeDonationsTracker = ({extraLifeInformation}: {extraLifeInformation: IExtraLife}) => {
    //console.log(extraLifeInformation);
    return (
        <div className="">
            <div className="mx-auto max-w-7xl py-8 sm:py-10 sm:px-6 lg:px-8">
                <div className="relative isolate overflow-hidden bg-gray-900 px-6 pt-16 sm:rounded-3xl sm:px-16 md:pt-24 lg:flex lg:gap-x-20 lg:px-24 lg:pt-0">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1024 1024"
                        className="absolute top-1/2 left-1/2 -z-10 h-[64rem] w-[64rem] -translate-y-1/2 sm:left-full sm:-ml-80 lg:left-1/2 lg:ml-0 lg:translate-y-0 lg:-translate-x-1/2"
                        aria-hidden="true"
                    >
                        <circle cx={512} cy={512} r={512} fill="url(#759c1415-0410-454c-8f7c-9a820de03641)" fillOpacity="0.7" />
                        <defs>
                            <radialGradient
                                id="759c1415-0410-454c-8f7c-9a820de03641"
                                cx={0}
                                cy={0}
                                r={1}
                                gradientUnits="userSpaceOnUse"
                                gradientTransform="translate(512 512) rotate(90) scale(512)"
                            >
                                <stop stopColor="#26c2eb" />
                                <stop offset={1} stopColor="#26c2eb" stopOpacity={0} />
                            </radialGradient>
                        </defs>
                    </svg>

                    <div className="mx-auto text-center py-8 lg:mx-0 lg:flex-auto lg:py-14 lg:text-left">
                        <div className="flex justify-between">
                            <div className="flex ">
                                <p className="text-white">{`RAISED: $${extraLifeInformation.sumPledges} USD`}</p>
                            </div>
                            <div className="flex ">
                                <p className="text-white">{`GOAL: $${extraLifeInformation.fundraisingGoal} USD`}</p>
                            </div>
                        </div>

                        <div className="relative mt-2">
                            <div className={`absolute inset-0 w-full h-5 bg-gray-500 rounded-xl`} />
                            <div className={`absolute inset-0 w-full h-5 bg-white rounded-xl`} style={{ width: extraLifeInformation.percentageCompleted > 100 ? "100%" : extraLifeInformation.percentageCompleted + "%" }} />
                            <div className="absolute inset-0 mt-0.5">
                                <div className="flex flex-row">
                                    {/* {milestonesElements} */}
                                    {extraLifeInformation.milestones.map((milestone, index) => {

                                        if (index > extraLifeInformation.numMilestones - 1) return;

                                        return (<>
                                            <div id={milestone.id.toString()} className="flex items-end justify-end relative" style={{ flex: milestone.fundraisingGoal / extraLifeInformation.fundraisingGoal }}>
                                                <div
                                                    className={`w-4 h-4 border border-black ${extraLifeInformation.sumPledges <= milestone.fundraisingGoal ? "bg-white" : "extra-life-milestone-blue"} rounded-xl`}
                                                    data-tooltip-id={`my-tooltip-${index}`}
                                                />
                                                <Tooltip
                                                    id={`my-tooltip-${index}`}
                                                    place={"bottom"}
                                                    content={"$" + milestone.fundraisingGoal + ": " + milestone.description}
                                                    style={{ backgroundColor: "#26c2eb", color: "#000", opacity: 1 }}
                                                />
                                            </div>
                                            {(milestone.id === extraLifeInformation.numMilestones - 1) && (
                                                <div
                                                    id={(milestone.id + 1).toString()}
                                                    className="flex items-end justify-end"
                                                    style={{ flex: (extraLifeInformation.sumPledges - milestone.fundraisingGoal) / extraLifeInformation.sumPledges }}
                                                />
                                            )}
                                        </>);
                                    })}

                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col mt-9">
                            <div className="flex">
                                <p className="text-white">{`Next milestone`}</p>
                            </div>
                            <div className="flex">
                                <p className="text-white">
                                    {`$${extraLifeInformation.milestones.find(milestone => milestone.fundraisingGoal > extraLifeInformation.sumPledges)?.fundraisingGoal}: 
                                    ${extraLifeInformation.milestones.find(milestone => milestone.fundraisingGoal > extraLifeInformation.sumPledges)?.description}`}
                                </p>
                            </div>
                        </div>

                        <div>
                            <div className="flex items-center justify-center mt-3">
                                <p className="text-white font-semibold shadow-sm">
                                    {"Any amount you can donate helps these kids!"}
                                </p>
                            </div>
                            <div className="mt-4 flex items-center justify-center">
                                <a
                                    target="_blank"
                                    href={extraLifeInformation.donationLink}
                                    className="rounded-md bg-white px-7 py-2 text-base font-semibold leading-7 text-gray-900 shadow-sm hover:bg-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                                >
                                    {"DONATE"}
                                </a>
                            </div>
                            <div className="mt-4 flex items-center justify-center">
                                <a
                                    target="_blank"
                                    href={extraLifeInformation.extraLifePage}
                                    className="px-3.5 py-1.5 text-white hover:text-red-500"
                                >
                                    {"Benefiting My Local Children's Hospital"}
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ExtraLifeDonationsTracker;